module.exports = __webpack_public_path__ + "static/oldman-0805ec2f37a161410523e3469ebcca62.png";